import {
  Module,
  VuexModule,
  Action,
} from 'vuex-module-decorators';

import {
  FETCH_MARKETING_REPORT,
  BASE_URL,
  M_POST,
} from '@/utils/api';

import Vue from 'vue';

@Module({ name: 'marketingreport' })
export default class MarketingReport extends VuexModule {
  @Action
  FetchMarteingReport(params: any) {
    return Vue.axios({
      url: BASE_URL + FETCH_MARKETING_REPORT,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => {
        if (data.status.code === 0) {
          const item = data.data;
          return item;
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }
}
